import styled from 'react-emotion'
import { menuWidth, borderRadius, border, z, space } from '../../style'
import { StyledFormElement as FormElement } from './FormElement'
import { withProps } from 'recompose'

export const MenuElement = styled('div')(({ placement, outOfBoundaries }) => {
  const style = {
    label: 'Menu',
    width: menuWidth,
    border: border,
    borderRadius: borderRadius,
    background: 'white',
    zIndex: z.menu,
    position: 'relative',

    maxHeight: `calc(100vh - ${space.large * 2}px)`,
    overflow: 'auto',

    display: outOfBoundaries && 'none',

    [FormElement]: {
      border: 'none',
      flex: 1 // full width
      // width: '100%', // full width - needed for input elements
    }
  }
  if (placement) {
    if (placement.match(/^right/)) style.marginLeft = space.default
    if (placement.match(/^left/)) style.marginRight = space.default
    if (placement.match(/^bottom/)) style.marginTop = space.default
    if (placement.match(/^top/)) style.marginBottom = space.default
  }

  return style
})

window.me = MenuElement

export const Menu = withProps(({ className = '' }) => ({
  className: 'ignore-react-onclickoutside ' + className
}))(MenuElement)

Menu.className = MenuElement.toString()

Menu.Divider = styled('hr')({
  label: 'MenuDivider',
  border: 'none',
  borderTop: border,
  margin: 0
})

// Menu.Row = styled(FormElement)(() => ({
//   label: 'MenuRow',
//   display: 'flex',
//   // flex-wrap: wrap;  // alows flex-basis:100% items to sit above each other
//   '&:not(:last-child)': {
//     borderBottom: border
//   },
//   [FormElement]: {
//     border: 'none',
//     '&:not(:last-child)': {
//       borderRadius: 0,
//       borderRight: border
//     },
//     padding: 0,
//     width: 'auto',
//     height: '100%', // TODO fix form-element heights
//     flex: 'inherit',
//   }
// }))

export default Menu
